import { Router } from '@angular/router';
import { CommonService } from './common.service';
import { IconService } from './icons-setting/Icons.service';
import { Component, HostListener } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less']
})
export class AppComponent {
  constructor(private iconService: IconService, public commonService: CommonService, private router: Router, private titleService: Title) {
    this.iconService.registerIcons();
    this.titleService.setTitle(this.commonService.projectTitle);
    router.canceledNavigationResolution = 'computed';
    // window.screen.orientation['lock']('landscape');
    // let orientation: any = window.screen.orientation;
    // orientation['lock']('portrait');
    /* var width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
    var height = (window.innerHeight > 0) ? window.innerHeight : screen.height;
    alert("width: " + width + ", height: " + height + ", orientation: " + screen.orientation.type); */

  }

  @HostListener('window:focus', ['$event'])
  onFocus(event: any): void {

    if (location.pathname.indexOf('WebViewer') < 0) {
      if (!this.commonService.ProjectLSData.currentRoute) {
        this.commonService.ProjectLSData.currentRoute = '';
        this.commonService.setProjectLSData();
        this.router.navigate([this.commonService.ProjectLSData.currentRoute]);
      } else if (this.commonService.ProjectLSData.currentRoute != location.pathname) {
        this.router.navigate([this.commonService.ProjectLSData.currentRoute ? this.commonService.ProjectLSData.currentRoute : '']);
      }

      if (this.commonService.ProjectLSData.currentRoute.indexOf('patientList') >= 0) {
        this.commonService.selectedPlace = 'patientList'
      } else if (this.commonService.ProjectLSData.currentRoute.indexOf('aboutpatient') >= 0) {
        this.commonService.selectedPlace = 'aboutpatient'
      }
      // this.commonService.selectedPlace = this.commonService.ProjectLSData.currentRoute ? this.commonService.ProjectLSData.currentRoute : 'patientList';
    }

  }
}
